import NietErnstigeBloedingenOnderDoac from "../../../../src/client/lta-antistolling/niet-ernstige-bloedingen-onder-doac.json";
import * as React from 'react';
export default {
  NietErnstigeBloedingenOnderDoac,
  React
};